import { UrlStatus } from "@authory-packages/core";

export const getUrlStatusLabel = (status: string) => {
  switch (status) {
    case UrlStatus.ShivaContentExtraction:
      return "Custom Extraction";
    case UrlStatus.DynamicAnalyzeCheck:
      return "Check";
    default:
      return status;
  }
};
